import React from 'react';
import clsx from 'clsx';

import { UIChartsIcon } from '@futrli/ui-components';
import { UIChartsIconName } from '@futrli/ui-components/components/icons/custom/graph-icon';

import { WIDGET_TYPES } from '../../../types';

import styles from './available-chart-types.scss';

export enum AvailableChartTypesSizes {
  SMALL = 'small',
  MEDIUM = 'medium'
}

interface AvailableChartTypesProps {
  className?: string;
  currentWidgetType?: WIDGET_TYPES;
  onClick?: (event: React.MouseEvent<HTMLSpanElement, MouseEvent>, item: WIDGET_TYPES) => void;
  onDragStart?: (event: React.DragEvent<HTMLSpanElement>, item: WIDGET_TYPES) => void;
  size?: AvailableChartTypesSizes;
  widgetTypes?: WIDGET_TYPES[];
}

export const AvailableChartTypes = ({
  className,
  currentWidgetType,
  onClick,
  onDragStart,
  size = AvailableChartTypesSizes.SMALL,
  widgetTypes = Object.values(WIDGET_TYPES)
}: AvailableChartTypesProps) => {
  return (
    <div className={clsx(styles.chartTypes, className)}>
      {widgetTypes.map(widgetType => (
        <span
          key={widgetType}
          id={`available-chart-type-${widgetType}`}
          data-testid="available-chart-type"
          className={clsx(styles.chartIcon, styles[size], {
            [styles.chartIconSelected]: widgetType === currentWidgetType
          })}
          draggable={!!onDragStart}
          onDragStart={onDragStart ? e => onDragStart?.(e, widgetType) : undefined}
          onClick={onClick ? e => onClick?.(e, widgetType) : undefined}
        >
          <UIChartsIcon iconName={(widgetType as unknown) as UIChartsIconName} />
        </span>
      ))}
    </div>
  );
};
